import * as React from "react";
import { JSX } from "react/jsx-runtime";
const MessageIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={12}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5123 0.400024H1.82887C0.930459 0.400024 0.164169 1.10002 0.164169 1.97502V10.075C0.164169 10.925 0.904035 11.65 1.82887 11.65H14.5123C15.4107 11.65 16.177 10.95 16.177 10.075V1.95002C16.177 1.10002 15.4107 0.400024 14.5123 0.400024ZM14.5123 1.52502C14.5387 1.52502 14.5651 1.52502 14.5915 1.52502L8.17057 5.42502L1.7496 1.52502C1.77602 1.52502 1.80244 1.52502 1.82887 1.52502H14.5123ZM14.5123 10.475H1.82887C1.56463 10.475 1.35324 10.275 1.35324 10.025V2.62502L7.5364 6.37502C7.72137 6.50002 7.93276 6.55002 8.14415 6.55002C8.35554 6.55002 8.56693 6.50002 8.75189 6.37502L14.9351 2.62502V10.05C14.9879 10.3 14.7765 10.475 14.5123 10.475Z"
      fill="#64748B"
    />
  </svg>
);
export default MessageIcon;
